export const getUnpaidGdsServicesCountByRfisc = (order, rfisc = 'RG1') => {
    var _a, _b;
    let count = 0;
    for (const traveller of order.travellers) {
        if (!((_b = (_a = traveller.services) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.services)) {
            continue;
        }
        for (const service of traveller.services.gdsServices.services) {
            const aviaOrderService = order.additionalServices.gdsServices.services.find(additionalService => service.serviceId === additionalService.id && additionalService.rfisc === rfisc);
            if (!aviaOrderService) {
                continue;
            }
            count += service.count - service.confirmedCount;
        }
    }
    return count;
};
